module.exports = __webpack_public_path__ + "img/group_add_opsz20B.64372560.svg";